import {useState} from 'react'

import Style from './style'
import MainHeader from 'widget/MainHeader'
import ITStyle from 'shared/style/inputTableStyle'
import usePostFranchiseManager from 'entity/franchise/usePostFranchiseManager'
import usePostSubManager from 'entity/sub-manager/usePostSubManager'
import {convertRoleAsName} from 'shared/constant/lookup/role'

const SubManagerCreate = () => {
	const [formData, setFormData] = useState({
		name: '',
		contact: '',
		id: '',
		password: '',
		role_type: '',
		store_name: '',
	})

	const [errors, setErrors] = useState({})
	const [postManager, isCreating] = usePostSubManager()

	const validatePasswordFormat = (password) => {
		const hasLetter = /[a-zA-Z]/.test(password)
		const hasNumber = /[0-9]/.test(password)
		const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password)
		return (
			hasLetter &&
			hasNumber &&
			hasSpecialChar &&
			password.length >= 6 &&
			password.length <= 20
		)
	}

	const handleInputChange = (field, value) => {
		setFormData((prev) => ({...prev, [field]: value}))
		if (errors[field]) {
			setErrors((prev) => ({...prev, [field]: ''}))
		}
	}

	const handleSubmit = () => {
		const newErrors = {}

		const nameRegx = /^[a-zA-Z가-힣]{1,20}$/

		if (!formData.name) newErrors.name = '이름을 입력하세요'
		else if (!nameRegx.test(formData.name))
			newErrors.name = '공백, 숫자, 특수문자 제외 1-20자 이내로 입력하세요'

		if (!formData.id) newErrors.id = '아이디를 입력하세요'
		if (formData.id && (formData.id.length < 1 || formData.id.length > 20))
			newErrors.id = '1-20자 이내로 입력하세요'

		if (!formData.password) newErrors.password = '비밀번호를 입력하세요'
		else if (!validatePasswordFormat(formData.password))
			newErrors.password =
				'비밀번호는 6-20자 이내의 문자, 숫자, 특수문자를 각각 최소 1개 포함해야 합니다'

		if (!formData.role_type) newErrors.role_type = '역할을 선택하세요'

		if (formData.role_type === '12' && !formData.store_name)
			newErrors.store_name = '브랜드명을 입력하세요'

		if (Object.keys(newErrors).length > 0) {
			setErrors(newErrors)
			return
		}

		const submitData = {
			id: formData.id,
			password: formData.password,
			name: formData.name,
			...(formData.contact ? {contact: formData.contact} : {}),
			role_type: parseInt(formData.role_type),
		}

		if (formData.role_type === '12') {
			submitData.store_name = formData.store_name
		}

		postManager(submitData)
	}

	const btnList = [
		{
			label: '생성',
			clickEvent: handleSubmit,
			loading: isCreating,
		},
	]

	return (
		<Style.Wrapper>
			<MainHeader btnList={btnList} title='매니저 계정 생성' />

			<ITStyle.TableDiv>
				<ITStyle.TableElement>
					<h2>
						이름<span>*</span>
					</h2>
					<Style.InputWrapper>
						<Style.Input
							placeholder='40자 이내로 입력하세요'
							value={formData.name}
							onChange={(e) => handleInputChange('name', e.target.value)}
						/>
						{errors.name && <Style.ErrorText>{errors.name}</Style.ErrorText>}
					</Style.InputWrapper>
				</ITStyle.TableElement>

				<ITStyle.TableElement>
					<h2>연락처</h2>
					<Style.InputWrapper>
						<Style.Input
							placeholder='플레이스홀더'
							value={formData.contact}
							onChange={(e) => handleInputChange('contact', e.target.value)}
						/>
					</Style.InputWrapper>
				</ITStyle.TableElement>

				<ITStyle.TableElement>
					<h2>
						아이디<span>*</span>
					</h2>
					<Style.InputWrapper>
						<Style.Input
							placeholder='로그인 아이디를 입력하세요'
							value={formData.id}
							onChange={(e) => handleInputChange('id', e.target.value)}
						/>
						{errors.id && <Style.ErrorText>{errors.id}</Style.ErrorText>}
					</Style.InputWrapper>
				</ITStyle.TableElement>

				<ITStyle.TableElement>
					<h2>
						비밀번호<span>*</span>
					</h2>
					<Style.InputWrapper>
						<Style.Input
							type='password'
							placeholder='6자 이상 입력하세요'
							value={formData.password}
							onChange={(e) => handleInputChange('password', e.target.value)}
						/>
						{errors.password && (
							<Style.ErrorText>{errors.password}</Style.ErrorText>
						)}
					</Style.InputWrapper>
				</ITStyle.TableElement>

				<ITStyle.TableElement>
					<h2>
						역할<span>*</span>
					</h2>
					<Style.InputWrapper>
						<Style.Select
							value={formData.role_type}
							onChange={(e) => handleInputChange('role_type', e.target.value)}
						>
							<option value=''>== 선택 ==</option>
							<option value='10'>{convertRoleAsName[10]}</option>
							<option value='11'>{convertRoleAsName[11]}</option>
						</Style.Select>
						{errors.role_type && (
							<Style.ErrorText>{errors.role_type}</Style.ErrorText>
						)}
					</Style.InputWrapper>
				</ITStyle.TableElement>
			</ITStyle.TableDiv>
		</Style.Wrapper>
	)
}

export default SubManagerCreate
